var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0675 27.9999C28.0842 27.9999 28.7268 26.9078 28.2331 26.0191L17.1658 6.09792C16.6578 5.18351 15.3427 5.18351 14.8347 6.09792L3.76736 26.0191C3.27364 26.9078 3.91626 27.9999 4.93291 27.9999H27.0675ZM14.6669 13.3333C14.6669 12.5969 15.2638 11.9999 16.0002 11.9999C16.7366 11.9999 17.3336 12.5969 17.3336 13.3333V19.9999C17.3336 20.7363 16.7366 21.3333 16.0002 21.3333C15.2638 21.3333 14.6669 20.7363 14.6669 19.9999V13.3333ZM14.6669 23.9999C14.6669 23.2636 15.2638 22.6666 16.0002 22.6666C16.7366 22.6666 17.3336 23.2636 17.3336 23.9999C17.3336 24.7363 16.7366 25.3333 16.0002 25.3333C15.2638 25.3333 14.6669 24.7363 14.6669 23.9999Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.b5624edec2dde88d0078e7f95055461f.svg";
export { ForwardRef as ReactComponent };